'use client';

import { useEffect, useState } from 'react';

import { ProductModel } from '@/services/models/Product';

import ProductService from '@/services/isomorphic/ProductService';

/**
 * Fetches product data based on an ID.
 * 
 * @deprecated Use {@link useProductById} for loading and error state. This hook does not distinguish loading from failed lookups.
 * @param id - The product's ID.
 * @returns A Product Model.
 */
export const useProduct = (id: string): ProductModel | null => {
  const [product, setProduct] = useState<ProductModel | null>(null);

  useEffect(() => {
    let isStale = false;

    const fetchProduct = async (): Promise<void> => {
      const product = await ProductService.getProductDTOById(id);
      if (!isStale) {
        setProduct(ProductModel.from(product));
      }
    };

    fetchProduct();

    return () => {
      isStale = true;
    };
  }, [id]);

  return product;
};
